export const EVENT_CONSTANTS = {
    LOAN_CALCULATOR_CDP_ACTION: "Loan_calculator_CDP_action",
    CARD_VIEWED: "Card_viewed",
    IMPERFECTION_SEEN: "car imperfection section seen",
    CALCULATOR_SECTION_SEEN: "loan calculator section seen",
    TRADE_IN_BANNER_CTA_CLICKED: "trade in banner cta clicked",
    TRADE_IN_BANNER_ACTION: "clicked",
    CHECKOUT_INITIATED: "TD_Flow",
    EW_ACTIVE_VARIANT: "variant_assigned"
};

export const EVENT_DATA = {
    LOAN_CALCULATOR_CDP_ACTION: {
        eventCategory: "CDP Desktop variant B",
        eventAction: "Loan_calculator_CDP_action",
        eventLabel: "Calculator_CDP_clicked",
        event: "custom_event"
    },
    CARD_VIEWED: {
        eventCategory: "CDP Desktop variant B",
        eventAction: "Card_viewed",
        eventLabel: "{{Finance_CDP}}",
        event: "custom_event"
    },
    TRADE_IN_BANNER_ACTION: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "clicked",
        eventLabel: "trade_in_banner"
    },
    CHECKOUT_INITIATED: {
        eventCategory: "checkout_initiated",
        eventAction: "TD_Flow",
        eventLabel: "No",
        event: "checkout"
    },
    PRIORITISATION_MODAL_SEEN: {
        event: "prioritisation_modal_seen",
        eventCategory: "wishlist",
        eventAction: "clp/homepage/cdp",
        eventLabel: "<app id>"
    },
    EW_ACTIVE_VARIANT: {
        event: "custom_event",
        eventCategory: "ew_top_funnel",
        eventAction: "variant_assigned"
    },
    EW_ACTIVE_VARIANT_TRACKING: {
        event: "custom_event",
        eventCategory: "ew_tracking_event",
        eventAction: "variant_assigned_tracking_event"
    },
    CTA_OPTIMIZATION: {
        eventLabel: "Buy_online",
        eventAction: "cta_clicked",
        event: "custom_event",
        eventCategory: "CTA_optimisation"
    },
    CTA_OPTIMIZATION_EXPOSURE: {
        eventCategory: "CTA_optimisation",
        eventAction: "variant_assigned",
        event: "experiment"
    },
    PREMIUM_FEATURES_EXPOSURE: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "premium_features_gallery"
    },
    DEALER_COMMENTS_SEEN: {
        event: "custom_event",
        eventCategory: "Cars24_details_page",
        eventAction: "dealer_comments_seen",
        eventLabel: "" // app id
    },
    DEALER_COMMENTS_READ_MORE_CLICKED: {
        event: "custom_event",
        eventCategory: "Cars24_details_page",
        eventAction: "dealer_comments_read_more_clicked",
        eventLabel: "" // app id
    },
    DEALER_PROFILE_SEEN: {
        event: "custom_event",
        eventCategory: "Cars24_details_page",
        eventAction: "dealer_profile_seen",
        eventLabel: "" // app id
    },
    PPSR_REPORT_BANNER_SEEN: {
        event: "custom_event",
        eventCategory: "Cars24_details_page",
        eventAction: "ppsr_report_banner_seen",
        eventLabel: "" // generation_in_progress/generated
    },
    SERVICE_HISTORY_SEEN: {
        event: "custom_event",
        eventCategory: "Cars24_details_page",
        eventAction: "service_history_seen",
        eventLabel: "" // generation_in_progress/generated
    },
    CLASSIFIEDS_EXPOSURE: {
        eventCategory: "classifieds",
        event: "experiment"
    }
};
